import * as http from '../util/request'
/**
 * 测试
 * @param {object} data   
 */

/**
 * @description: 
 * @param {*} query
 * @return {*}
 */

// 阿里云上传
const ossFileUpdate = (query) => {
  return http.post('/aliyunOss/uploadFile', query)
}
// 获取基础数据
const getBasicData = (query) => {
  return http.post('/mBaseData/getList', query)
}
// 新增基础数据
const saveBasicData = (query) => {
  return http.post('/mBaseData/saveOrUpdate', query)
}

const getBasicDataByCdType = (query) => {
  return http.fetch('/mBaseData/selectByCdTypeDt', query)
}




export {
  ossFileUpdate,
  getBasicData,
  getBasicDataByCdType,
  saveBasicData
}

